import React from 'react';
import { IconButton } from '@material-ui/core';

export function ParkModeHeader(props: {
    orderHeaderData: {
        headerClassName?: string;
        leftIcon?: (className?: string) => JSX.Element;
        title?: string;
        subtitle?: string;
        rightIcon?: (className?: string) => JSX.Element;
        renderFunction?: (className?: string) => JSX.Element;
    };
    handleRightBtn?: () => void;
    handleLeftBtn?: () => void;
    handleMiddleBtn?: () => void;

}) {
    const { orderHeaderData } = props
    return (
        <div className={orderHeaderData.headerClassName ? `orderHeader ${orderHeaderData.headerClassName}` : 'orderHeader'}>

            <IconButton className='icoButton' disabled={!orderHeaderData.leftIcon} onClick={() => orderHeaderData.leftIcon && props.handleLeftBtn?.()}>
                {orderHeaderData.leftIcon?.()}
            </IconButton>
            <div>
                {
                    typeof orderHeaderData.renderFunction !== 'function' ?
                        <p>{orderHeaderData.title}</p>
                        : orderHeaderData.renderFunction()
                }
                {
                    orderHeaderData.subtitle && <span>{orderHeaderData.subtitle}</span>
                }
            </div>
            <IconButton className='icoButton' disabled={!orderHeaderData.rightIcon} onClick={(evt: any) => {
                evt.stopPropagation()
                orderHeaderData.rightIcon && props.handleRightBtn?.()
            }}>
                {orderHeaderData.rightIcon?.()}
            </IconButton>

        </div >
    )
}